<template>
  <div class="h-full flex items-center" :style="wrapperStyle">
    <router-link to="/" class="inline-flex items-center">
      <img :src="`/logos/${platform || 'logo_rgb'}.png`" :style="logoStyle" alt="logo" />
      <el-collapse-transition>
        <span v-if="!collapse" class="text-19px text-white">{{ title }}</span>
      </el-collapse-transition>
    </router-link>
  </div>
</template>
<script lang="ts" setup>
const appStore = useAppStore();
const { collapse, ROSA_TITLE: title, ROSA_PLATFORM: platform } = storeToRefs(appStore);
const wrapperStyle = computed(() => (collapse.value ? '' : 'padding: 0 10px;'));
const logoStyle = computed(() => {
  return collapse.value ? `width: 54px` : `width: calc(var(--nav-bar-height) - 20px);`;
});
</script>
